import axios from "axios";
import { APP_SETTINGS } from "../../config";

//Get Employee List
export function getAllZoomMeeting(data) {
  return axios.get(
    APP_SETTINGS.API_PATH.ZOOM.getAllMeetings +
      `?page_number=${data.page_number ? data.page_number : 1}&email=${
        data.email
      }&next_page_token=${data.next_page_token ? data.next_page_token : ""}`
  );
}

export function zoomInstantMeeting(data) {
  return axios.post(APP_SETTINGS.API_PATH.ZOOM.instantMeeting, data);
}

export function zoomScheduleMeeting(data) {
  return axios.post(APP_SETTINGS.API_PATH.ZOOM.scheduleMeeting, data);
}

export function zoomUpdateScheduleMeeting(id, data) {
  return axios.patch(
    APP_SETTINGS.API_PATH.ZOOM.updateScheduleMeeting.replace(":meetingId", id),
    data
  );
}

// export function zoomOAuthMeeting(data) {
//   return axios.get(
//     APP_SETTINGS.API_PATH.ZOOM.zoomOAuth + `?email=${data.email}`
//   );
// }

export function meetingSingleRecord(meetingId, email) {
  var url = `${APP_SETTINGS.API_PATH.ZOOM.meetingSingleRecord}?meetingId=${meetingId}&email=${email}`;
  var response = axios.get(url);
  return response;
}
